import React from 'react';
import _ from 'lodash';
import CsvRunDetail from 'app/features/connection-runs/components/csv/CsvRunDetail';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as organisationsActions from 'app/ducks/organisations/actions';
import * as competitionsActions from 'app/ducks/competitions/actions';
import * as connectionsActions from 'app/ducks/connections/actions';
import * as connectionRunsActions from 'app/ducks/connectionRuns/actions';

import * as organisationSelectors from 'app/ducks/organisations/selectors';
import * as competitionSelectors from 'app/ducks/competitions/selectors';
import * as connectionSelectors from 'app/ducks/connections/selectors';
import * as connectionRunSelectors from 'app/ducks/connectionRuns/selectors';

interface IConnectionRunDetailsProps {
  appReady: any;
  actions: any;
  match: any;
  errors: any;
  connections: any;
  connectionRuns: any;
}

function selector(state): any {
  return {
    organisations: organisationSelectors.getOrganisations(state),
    competitions: competitionSelectors.getCompetitions(state),
    connections: connectionSelectors.getConnections(state),
    connectionRuns: connectionRunSelectors.getConnectionRuns(state),
  };
}

const actionCreators = _.merge(
  organisationsActions,
  competitionsActions,
  connectionsActions,
  connectionRunsActions,
);

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class ConnectionRunDetails extends React.Component<
  IConnectionRunDetailsProps,
  {}
> {
  static defaultProps: IConnectionRunDetailsProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    errors: undefined,
    connections: undefined,
    connectionRuns: undefined,
  };

  componentDidMount = (): void => {
    this.props.actions.getConnectionRun(
      this.props.match.params.connectionRunId,
    );
  };

  render(): React.ReactNode {
    if (!_.isEmpty(this.props.connectionRuns.currentConnectionRun)) {
      if (this.props.connectionRuns.currentConnectionRun.code === 'csv') {
        return <CsvRunDetail {...this.props} />;
      }
    }
    return <h2>No connection run found.</h2>;
  }
}
